import StarkleApiV1 from "./StarkleApiV1";

export default new StarkleApiV1();